import React from 'react'

const Title = ({title}) => (
  <div className="container">
    <h1 className="pageTitle"> { title } </h1>
  </div>
)

export default Title
